import styles from "./post-preview.module.css";
import { IParagraph, IPostInsight } from "../../../interfaces/insightPost";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faArrowUp,
  faArrowDown,
} from "@fortawesome/free-solid-svg-icons";

type Props = {
  post?: IPostInsight;
  paragraphs?: IParagraph[];
  setParagraphs: React.Dispatch<React.SetStateAction<IParagraph[]>>;
};

const PostPreview = ({ post, paragraphs, setParagraphs }: Props) => {
  const createList = (list: string[]): any => {
    return list.map((item, index) => {
      return (
        <li key={index} className={styles.lista_item}>
          {item}
        </li>
      );
    });
  };

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "";
    }
    date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const onClickMoveItemUp = (itemToMove: IParagraph) => {
    if (!paragraphs) return;
    const indexItem = paragraphs.findIndex((el) => el === itemToMove);

    if (indexItem <= 0) return;

    const newParagraphs = [...paragraphs];

    [newParagraphs[indexItem - 1], newParagraphs[indexItem]] = [
      newParagraphs[indexItem],
      newParagraphs[indexItem - 1],
    ];
    setParagraphs(newParagraphs || []);
    createPreview(newParagraphs || []);
  };

  const onClickRemoveItem = (itemToRemove: IParagraph) => {
    const newList = paragraphs?.filter((el) => el !== itemToRemove);

    setParagraphs(newList || []);
    createPreview(newList || []);
  };

  const onClickMoveItemDown = (itemToMove: IParagraph) => {
    if (!paragraphs) return;
    const indexItem = paragraphs.findIndex((el) => el === itemToMove);

    if (indexItem === -1 || indexItem >= paragraphs.length - 1) return;

    const newParagraphs = [...paragraphs];

    [newParagraphs[indexItem], newParagraphs[indexItem + 1]] = [
      newParagraphs[indexItem + 1],
      newParagraphs[indexItem],
    ];
    setParagraphs(newParagraphs || []);
    createPreview(newParagraphs || []);
  };

  const createPreview = (paragraphsList: IParagraph[]) => {
    return paragraphsList?.map((item) => {
      if (item.type === "text") {
        return (
          <div className={styles.itemPreview_withBtns}>
            <div className={styles.text_box}>
              <p className={styles.text_paragraph}>{item.text}</p>
            </div>
            <div className={styles.btns_box}>
              <button
                className={styles.btns}
                onClick={() => onClickMoveItemUp(item)}
              >
                <FontAwesomeIcon icon={faArrowUp} />
              </button>
              <button
                className={styles.btns}
                onClick={() => onClickRemoveItem(item)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
              <button
                className={styles.btns}
                onClick={() => onClickMoveItemDown(item)}
              >
                <FontAwesomeIcon icon={faArrowDown} />
              </button>
            </div>
          </div>
        );
      }

      if (item.type === "image") {
        return (
          <div className={styles.itemPreview_withBtns}>
            <div className={styles.img_box}>
              <img src={item.text} alt="" />
            </div>
            <div className={styles.btns_box}>
              <button
                className={styles.btns}
                onClick={() => onClickMoveItemUp(item)}
              >
                <FontAwesomeIcon icon={faArrowUp} />
              </button>
              <button
                className={styles.btns}
                onClick={() => onClickRemoveItem(item)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
              <button
                className={styles.btns}
                onClick={() => onClickMoveItemDown(item)}
              >
                <FontAwesomeIcon icon={faArrowDown} />
              </button>
            </div>
          </div>
        );
      }

      if (item.type === "list") {
        return (
          <div className={styles.itemPreview_withBtns}>
            <div className={styles.text_box}>
              <p className={styles.text_paragraph}>{item.text}</p>
              <ul className={styles.servico_lista}>
                {createList(item.list || [])}
              </ul>
            </div>
            <div className={styles.btns_box}>
              <button
                className={styles.btns}
                onClick={() => onClickMoveItemUp(item)}
              >
                <FontAwesomeIcon icon={faArrowUp} />
              </button>
              <button
                className={styles.btns}
                onClick={() => onClickRemoveItem(item)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
              <button
                className={styles.btns}
                onClick={() => onClickMoveItemDown(item)}
              >
                <FontAwesomeIcon icon={faArrowDown} />
              </button>
            </div>
          </div>
        );
      }

      if (item.type === "link") {
        return (
          <div className={styles.itemPreview_withBtns}>
            <div className={styles.link_box}>
              <p className={styles.text_link}>{item.text}</p>
              <p className={styles.text_link}>
                <a href={item.link}>
                  <b>{item.link}</b>
                </a>
              </p>
            </div>
            <div className={styles.btns_box}>
              <button
                className={styles.btns}
                onClick={() => onClickMoveItemUp(item)}
              >
                <FontAwesomeIcon icon={faArrowUp} />
              </button>
              <button
                className={styles.btns}
                onClick={() => onClickRemoveItem(item)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
              <button
                className={styles.btns}
                onClick={() => onClickMoveItemDown(item)}
              >
                <FontAwesomeIcon icon={faArrowDown} />
              </button>
            </div>
          </div>
        );
      }

      if (item.type === "video") {
        const videoCode = item.text ? item.text.split("/").pop() : "";

        return (
          <div className={styles.itemPreview_withBtns}>
            <div className={styles.video_box}>
              <iframe
                width="315"
                height="560"
                src={`https://www.youtube.com/embed/${videoCode}`}
                title="YouTube video player"
                style={{ border: 0 }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
            <div className={styles.btns_box}>
              <button
                className={styles.btns}
                onClick={() => onClickMoveItemUp(item)}
              >
                <FontAwesomeIcon icon={faArrowUp} />
              </button>
              <button
                className={styles.btns}
                onClick={() => onClickRemoveItem(item)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
              <button
                className={styles.btns}
                onClick={() => onClickMoveItemDown(item)}
              >
                <FontAwesomeIcon icon={faArrowDown} />
              </button>
            </div>
          </div>
        );
      }

      return <p> </p>;
    });
  };

  return (
    <main className={styles.post_main}>
      <section className={styles.descricao_section}>
        <h1 className={styles.post_title}>{post?.title || "Título do Post"}</h1>
        <div className={styles.post_date}>
          <span>
            <b>{`Postado por ${post?.username}`}</b>
          </span>
          <span>
            <i>{`Em ${post?.date ? formatDate(post.date) : ""}`}</i>
          </span>
        </div>
        <>{createPreview(paragraphs || [])}</>
      </section>
    </main>
  );
};

export default PostPreview;
